/* eslint-disable */

import { makeStyles, Switch } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import { CloudDownload, Delete, LinkSharp, Visibility } from "@material-ui/icons";
import Edit from "@material-ui/icons/Edit";
import Search from "@material-ui/icons/Search";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import { Button as ButtonMui, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Modal from "@mui/material/Modal";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Select from "components/Select/Select";
import TablePaginate from "components/TablePaginate/TablePaginate";
import { chainOptions } from "const";
import { ethers } from "ethers";
import { isAddress } from "ethers/lib/utils.js";
import detectAndSwitchChain from "helper/switchChain";
import PropTypes from "prop-types";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { collectionService } from "services/collectionService";
import CSAQRnoshad from "../../assets/img/CSAQRnoshad.png";
import { abi as MarketFeeABI } from "../../contracts/setMarketFee.json";
import { abi as RoyaltyV2ABI } from "../../contracts/setRoyaltyV2";
import { attributesService } from "../../services/rarityService";
import EditCollectionTier from "./EditCollectionTier";

const FE_LINK = process.env.REACT_APP_FE_LINK;

const getRoyalAddress = async () => {
  if (!window.ethereum) return;
  const { ethereum } = window;
  const provider = new ethers.providers.Web3Provider(ethereum);
  const { chainId } = await provider.getNetwork();
  return chainOptions().find((c) => +c.value === +chainId)?.config?.royalAddress;
};

const getRoyaltyAddress = async (chainId) => {
  return chainOptions().find((c) => +c.value === +chainId)?.config?.royalAddress;
};

const getMarketFeeAddress = async () => {
  if (!window.ethereum) return;
  const { ethereum } = window;
  const provider = new ethers.providers.Web3Provider(ethereum);
  const { chainId } = await provider.getNetwork();
  return chainOptions().find((c) => +c.value === +chainId)?.config?.marketFeeAddress;
};

const useStyles = makeStyles({
  filter: {
    display: "flex",
    gap: "40px",
  },
});

const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  bgcolor: "#fff",
  color: "#000",
  transform: "translate(-50%, -50%)",
  width: 450,
  boxShadow: 24,
  p: 2,
  borderRadius: "5px",
};

const contractInterface = {
  1: "ERC721",
  2: "ERC1155",
};

export default function CollectionIndex() {
  const classes = useStyles();
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(0);
  const [size] = useState(10);
  const [count, setCount] = useState(0);
  const [open, setOpen] = useState(false);
  const handleOpen = useCallback(() => setOpen(true), []);
  const [isImport, setIsImport] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isLoadingCalculateRarity, setLoadingCalculateRarity] = useState(false);
  const [wallet, setWallet] = useState("");
  const [royalty, setRoyalty] = useState({});
  const [royalties, setRoyalties] = useState([]);
  const [payee, setPayee] = useState("");
  const [marketFee, setMarketFee] = useState("");
  const [signer, setSigner] = useState();
  const [collection, setCollection] = useState({ address: "", id: "", chainId: 25 });
  const [loadingDeleteFee, setLoadingDeleteFee] = useState(false);
  const [loading, setLoading] = useState(false);
  const [chainId, setChainId] = useState("-1");

  const [openRoyalty, setOpenRoyalty] = useState(false);
  const [openMarketFee, setOpenMarketFee] = useState(false);

  const handleOpenRoyalty = async (cell) => {
    const chainId = cell.row.original.chainId;
    const isSwitch = await detectAndSwitchChain(chainId);
    if (!isSwitch) return;
    setOpenRoyalty(true);
    setRoyalties(
      cell.row.original.royalties?.map((item) => ({
        ...item,
        royalty: item.royalty ? Number(ethers.BigNumber.from(item.royalty).toString()) / 100 : 0,
      })),
    );
    setCollection({
      address: cell.row.original.address,
      id: cell.row.original._id,
      chainId,
    });
  };

  const handleCloseRoyalty = () => {
    setOpenRoyalty(false);
    setRoyalty("");
    setPayee("");
  };

  const handleOpenMarketFee = async (cell) => {
    const chainId = cell.row.original.chainId;
    const isSwitch = await detectAndSwitchChain(chainId);
    if (!isSwitch) return;
    setOpenMarketFee(true);
    setCollection({
      address: cell.row.original.address,
      id: cell.row.original._id,
      marketFee: cell.row.original.marketFee,
    });
    if (cell.row.original.marketFee > 0) setMarketFee(cell.row.original.marketFee / 100);
  };

  const handleCloseMarketFee = () => {
    setOpenMarketFee(false);
    setRoyalty("");
    setPayee("");
  };

  const handleClose = useCallback(() => {
    setOpen(false);
    setIsImport(!isImport);
  }, [isImport]);

  const handleCalculateRarity = async (cell) => {
    try {
      setLoadingCalculateRarity(true);
      const address = cell.row.original.address;
      await attributesService.calculateRarity(cell.row.original.chainId, address);
      toast.success("Job added to queue");
      const { data } = await collectionService.getByAddress(address);
      cell.row.original.calculateRarityRunning = true;
      if (Object.keys(data).length > 0) {
        const newData = items.map((col) => {
          if (col._id == data._id) {
            return {
              ...col,
              calculateRarityRunning: data.calculateRarityRunning,
              rankedNft: data.rankedNft,
            };
          } else {
            return col;
          }
        });
        if (newData.length > 0) {
          setItems(newData);
        }
      }

      setLoadingCalculateRarity(false);
    } catch (error) {
      setLoadingCalculateRarity(false);
      console.log("🍕 ~ error", error);
    }
  };

  const handRefreshMetadata = async (cell) => {
    try {
      setLoadingCalculateRarity(true);
      const address = cell.row.original.address;
      await collectionService.refreshAllMetadata(address);
      setLoadingCalculateRarity(false);
    } catch (error) {
      setLoadingCalculateRarity(false);
      console.log("🍕 ~ error", error);
    }
  };

  const getChainById = (id) => {
    const chain = chainOptions().find((c) => +c.value === +id);
    return chain ? chain.label : "Null";
  };

  const calculateTotalRoyalty = (royalties) => {
    if (!Array.isArray(royalties) || royalties.length === 0) return 0; // Kiểm tra royalties có hợp lệ không
    return royalties.reduce((total, item) => {
      const royaltyValue = item.royalty
        ? Number(ethers.BigNumber.from(item.royalty).toString())
        : 0;
      return total + royaltyValue;
    }, 0); // Bắt đầu với tổng là 0
  };
  const columns = useMemo(
    () => [
      {
        Header: "Thumbnail",
        accessor: "image",
        Cell: Thumbnail,
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Type",
        accessor: "contractInterface",
        Cell: function Type({ cell }) {
          return <strong style={{ fontSize: "12px" }}>{contractInterface[cell.value]}</strong>;
        },
      },
      {
        Header: "Reward Tier",
        accessor: "tier",
        Cell: function Tier(cell) {
          return <EditCollectionTier reload={handleRefresh} collection={cell?.row?.original} />;
        },
      },
      {
        Header: "Chain",
        accessor: "chainId",
        Cell: function Tier(cell) {
          return getChainById(cell.value);
        },
      },
      {
        Header: "Is Active",
        accessor: "activated",
        Cell: IsActivated,
      },
      {
        Header: "Featured",
        accessor: "featured",
        Cell: function featured({ cell }) {
          return (
            <strong>
              {cell.row.original.featured && cell.row.original.featured !== 0
                ? `Spot ${cell.row.original.featured}`
                : "---"}
            </strong>
          );
        },
      },
      {
        Header: "Launchpad",
        accessor: "isLaunchpad",
        align: "center",
        Cell: function isLaunchpad({ cell }) {
          const deployed = isAddress(cell.row.original.address) && +cell.row.original.address !== 0;
          return (
            <strong>{cell.value ? `Yes - ${deployed ? "Deployed" : "Not deploy"}` : ""}</strong>
          );
        },
      },
      {
        Header: "Royalty ",
        accessor: "royalty",
        align: "center",
        Cell: function ({ cell }) {
          return (
            <div>
              {cell.row.original.royalties?.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                  }}
                >
                  <span>{calculateTotalRoyalty(cell.row.original.royalties) / 100}%</span>
                  <CurrencyExchangeIcon
                    style={{
                      fontSize: "20px",
                      cursor: "pointer",
                      color: "#000",
                    }}
                    onClick={() => {
                      handleOpenRoyalty(cell);
                    }}
                  />
                </div>
              )}
              {cell.row.original.royalty ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                  }}
                >
                  <span>{cell.row.original.royalty / 100}</span>
                  <CurrencyExchangeIcon
                    style={{
                      fontSize: "20px",
                      cursor: "pointer",
                      color: "#000",
                    }}
                    onClick={() => {
                      handleOpenRoyalty(cell);
                    }}
                  />
                </div>
              ) : (
                <button
                  onClick={() => {
                    handleOpenRoyalty(cell);
                  }}
                  style={{
                    border: "none",
                    outline: "none",
                    background: "#4caf50",
                    padding: "10px",
                    borderRadius: 5,
                    margin: "0 auto",
                    cursor: "pointer",
                    color: "#fff",
                  }}
                >
                  {cell?.row?.original?.royalties?.length > 0 ? "Edit Royalty" : " Set Royalty"}
                </button>
              )}
            </div>
          );
        },
      },
      {
        Header: "Fee",
        accessor: "marketFee",
        align: "center",
        Cell: function ({ cell }) {
          return (
            <div>
              {cell.row.original?.marketFee ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                  }}
                >
                  <span>{cell.row.original?.marketFee / 100}</span>
                  <CurrencyExchangeIcon
                    style={{
                      fontSize: "20px",
                      cursor: "pointer",
                      color: "#000",
                    }}
                    onClick={() => {
                      handleOpenMarketFee(cell);
                    }}
                  />
                </div>
              ) : (
                <button
                  onClick={() => {
                    handleOpenMarketFee(cell);
                  }}
                  style={{
                    border: "none",
                    outline: "none",
                    background: "#4caf50",
                    padding: "10px",
                    borderRadius: 5,
                    margin: "0 auto",
                    cursor: "pointer",
                    color: "#fff",
                  }}
                >
                  Set Fee
                </button>
              )}
            </div>
          );
        },
      },
      {
        Header: "Badge",
        accessor: "badge",
        align: "center",
        Cell: function isLaunchpad({ cell }) {
          return (
            <strong
              style={{
                marginLeft: 10,
              }}
            >
              {cell.row.values?.badge ? (
                cell.row.values.badge === 1 ? (
                  <svg width="24" height="24" viewBox="0 0 12 12" fill="none">
                    <path
                      d="M4.78117 0.743103C5.29164 -0.247701 6.70826 -0.247701 7.21872 0.743103C7.52545 1.33846 8.21742 1.62509 8.8553 1.42099C9.91685 1.08134 10.9186 2.08304 10.5789 3.1446C10.3748 3.78247 10.6614 4.47445 11.2568 4.78117C12.2476 5.29164 12.2476 6.70826 11.2568 7.21872C10.6614 7.52545 10.3748 8.21742 10.5789 8.8553C10.9186 9.91685 9.91685 10.9186 8.8553 10.5789C8.21742 10.3748 7.52545 10.6614 7.21872 11.2568C6.70826 12.2476 5.29164 12.2476 4.78117 11.2568C4.47445 10.6614 3.78247 10.3748 3.1446 10.5789C2.08304 10.9186 1.08134 9.91685 1.42099 8.8553C1.62509 8.21742 1.33846 7.52545 0.743103 7.21872C-0.247701 6.70826 -0.247701 5.29164 0.743103 4.78117C1.33846 4.47445 1.62509 3.78247 1.42099 3.1446C1.08134 2.08304 2.08304 1.08134 3.1446 1.42099C3.78247 1.62509 4.47445 1.33846 4.78117 0.743103Z"
                      fill="#00FF0B"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.43961 4.23998C8.64623 4.43922 8.65221 4.76823 8.45297 4.97484L5.40604 8.13462L3.54703 6.20676C3.34779 6.00014 3.35377 5.67113 3.56039 5.47189C3.76701 5.27266 4.09602 5.27864 4.29526 5.48525L5.40604 6.63718L7.70475 4.25334C7.90398 4.04672 8.23299 4.04074 8.43961 4.23998Z"
                      fill="#000000"
                    ></path>
                  </svg>
                ) : cell.row.values.badge === 2 ? (
                  <svg
                    focusable="false"
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                  >
                    <path
                      fill="#FFB818"
                      d="M4.47 21h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0L2.74 18c-.77 1.33.19 3 1.73 3zM12 14c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1zm1 4h-2v-2h2v2z"
                    ></path>
                  </svg>
                ) : cell.row.values.badge === 4 ? (
                  <img
                    src={CSAQRnoshad}
                    alt="icon badge"
                    style={{ width: "30px", height: "30px" }}
                  />
                ) : cell.row.values.badge === 3 ? (
                  <svg
                    focusable="false"
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                  >
                    <path
                      fill="#5CC9C1"
                      d="m11.3 2.26-6 2.25C4.52 4.81 4 5.55 4 6.39v4.71c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V6.39c0-.83-.52-1.58-1.3-1.87l-6-2.25c-.45-.18-.95-.18-1.4-.01zm-1.07 12.57-2.12-2.12a.9959.9959 0 0 1 0-1.41c.39-.39 1.02-.39 1.41 0l1.41 1.41 3.54-3.54c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-4.24 4.24c-.38.4-1.02.4-1.41.01z"
                    ></path>
                  </svg>
                ) : (
                  <></>
                )
              ) : (
                <svg
                  focusable="false"
                  aria-hidden="true"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                >
                  <path
                    fill="#FFB818"
                    d="M4.47 21h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0L2.74 18c-.77 1.33.19 3 1.73 3zM12 14c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1zm1 4h-2v-2h2v2z"
                  ></path>
                </svg>
              )}
            </strong>
          );
        },
      },
      {
        Header: "Calculate rarity",
        Cell: function calculateRarity({ cell }) {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "60%",
              }}
            >
              <Tooltip title={`Click to start calculate rarity`}>
                {cell.row.original.calculateRarityRunning ? (
                  <CircularProgress />
                ) : (
                  <button
                    onClick={() => {
                      handleCalculateRarity(cell);
                    }}
                    style={{
                      border: "none",
                      outline: "none",
                      background: "#4caf50",
                      padding: "10px",
                      borderRadius: 5,
                      margin: "0 auto",
                      cursor: "pointer",
                      color: "#fff",
                    }}
                  >
                    Start - {cell.row.original.rankedNft ?? 0}
                  </button>
                )}
              </Tooltip>
            </div>
          );
        },
      },
      {
        Header: "Payment",
        Cell: function remove({ cell }) {
          return (
            <>
              <Link to={`/admin/collection-payment/${cell.row.original._id}`}>
                <button
                  color="info"
                  role="button"
                  style={{
                    border: "none",
                    outline: "none",
                    background: "#4caf50",
                    padding: "10px",
                    borderRadius: 5,
                    margin: "0 auto",
                    cursor: "pointer",
                    color: "#fff",
                  }}
                >
                  Edit
                </button>
              </Link>
            </>
          );
        },
      },
      {
        Header: "Action",
        Cell: function remove({ cell }) {
          return (
            <>
              <Action setItems={setItems} cell={cell} onCloseModal={handleClose}></Action>
            </>
          );
        },
      },
    ],
    [handleClose, isImport, open],
  );

  function Thumbnail({ cell }) {
    return <img src={cell.value} alt="" style={{ height: "50px" }} />;
  }

  Thumbnail.propTypes = {
    cell: PropTypes.any,
  };

  const handleRefresh = useCallback(() => {
    setIsImport(!isImport);
    setIsRefresh(true);
  }, [isImport, isRefresh]);

  async function fetchCollections() {
    const payload = {
      search,
      page,
      size,
      activated: status,
      chainId: +chainId,
    };
    if (!payload.chainId || payload.chainId === -1) delete payload.chainId;
    try {
      const { data } = await collectionService.list(payload);
      setItems(data.items);
      setCount(data.paginate.count);
      setPage(data.paginate.page);
      setIsRefresh(false);
    } catch (e) {
      console.log(e);
    }
  }

  const connectWallet = async () => {
    const { ethereum } = window;
    if (ethereum.isMetaMask) {
      const provider = new ethers.providers.Web3Provider(ethereum);
      const accounts = await provider.send("eth_requestAccounts", []);
      setSigner(provider.getSigner());
      setWallet(accounts[0]);
    } else {
      setMsg("Install MetaMask");
    }
  };

  const handleConfirmRoyalty = async () => {
    if (!signer) return;

    if (totalPercent > 15) {
      toast.error("Total royalty must not exceed 15%");
      return;
    }

    const contractPayload = royalties
      .filter(({ payee, royalty }) => payee && royalty)
      .map(({ payee, royalty }) => ({
        payee,
        royalty: royalty * 100,
      }));

    if (!contractPayload.length) {
      toast.error("No valid royalties data to update.");
      return;
    }

    setLoading(true);
    try {
      console.log("collection?.chainId: ", collection);

      const royalAddress = await getRoyaltyAddress(collection?.chainId);
      console.log("royalAddress: ", royalAddress);

      const contract = new ethers.Contract(royalAddress, RoyaltyV2ABI, signer);

      const tx = await contract.setRoyalties(collection.address, contractPayload);
      await tx.wait();

      if (tx.hash) {
        await collectionService.update(collection.id, { royalties: contractPayload });
        toast.success("Set royalty successfully");
        handleCloseRoyalty();
        handleRefresh();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteFee = async () => {
    try {
      if (!signer) return;
      setLoadingDeleteFee(true);
      const marketFeeAddress = await getMarketFeeAddress();
      const contract = new ethers.Contract(marketFeeAddress, MarketFeeABI, signer);
      const tx = await contract.setFee(collection.address, 0);
      await tx.wait();
      await new Promise((resolve) => setTimeout(resolve, 1000));
      if (tx.hash) {
        await collectionService.update(collection.id, {
          marketFee: 0,
        });
      }
      toast.success("Delete market fee successfully");
      handleCloseMarketFee();
      handleRefresh();
      setLoadingDeleteFee(false);
    } catch (error) {
      console.log(error);
      setLoadingDeleteFee(false);
    }
  };

  const handleConfirmMarketFee = async () => {
    try {
      if (+marketFee) {
        if (!signer) return;
        setLoading(true);
        const marketFeeAddress = await getMarketFeeAddress();
        const contract = new ethers.Contract(marketFeeAddress, MarketFeeABI, signer);
        const tx = await contract.setFee(collection.address, +marketFee * 100);
        await tx.wait();
        await new Promise((resolve) => setTimeout(resolve, 1000));
        if (tx.hash) {
          await collectionService.update(collection.id, {
            marketFee: +marketFee * 100,
          });
        }
        toast.success("Set market fee successfully");
        handleCloseMarketFee();
        handleRefresh();
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleAddRoyalties = (payee, royalty, index) => {
    const arr = Array.isArray(royalties) ? [...royalties] : [];

    // Nếu index tồn tại, cập nhật phần tử tại vị trí index
    if (index >= 0) {
      arr[index] = {
        ...arr[index], // Giữ nguyên các giá trị khác
        payee: payee ?? arr[index].payee, // Cập nhật payee
        royalty: royalty
          ? ethers.BigNumber.from(royalty)
          : ethers.BigNumber.from(arr[index]?.royalty || "0"), // Cập nhật royalty
      };
    } else {
      // Thêm mới nếu không tìm thấy
      arr.push({
        payee,
        royalty: ethers.BigNumber.from(royalty || "0"),
      });
    }

    setRoyalties(arr); // Cập nhật state
  };

  const calculateTotalPercent = () => {
    if (!royalties) return 0;

    return Object.values(royalties).reduce((total, item) => {
      if (item.royalty) {
        const royaltyValue = +item.royalty || 0;
        return item.royalty ? total + +royaltyValue : 0;
      }
      return total;
    }, 0);
  };

  const totalPercent = calculateTotalPercent();

  useEffect(() => {
    fetchCollections();
  }, [page, search, status, isImport, chainId]);
  console.log({ royalties });

  return (
    <div>
      {confirm}
      <Link to="/admin/collection-edit">
        <Button color="info">Create new Collections</Button>
      </Link>

      <Link to="/admin/collection-index-list">
        <Button color="info">Index</Button>
      </Link>

      <div className={classes.filter}>
        <CustomInput
          labelText="Search"
          id="search"
          formControlProps={{
            fullWidth: true,
          }}
          inputProps={{
            value: search,
            onChange: (e) => setSearch(e.target.value),
            endAdornment: (
              <InputAdornment position="end">
                <Search />
              </InputAdornment>
            ),
          }}
        />
        <Select
          label={"Chain"}
          value={chainId}
          onChange={setChainId}
          options={[{ value: "-1", label: "All" }, ...chainOptions()]}
        />

        <Select
          label={"Status"}
          value={status}
          onChange={setStatus}
          options={[
            { value: undefined, label: "ALL" },
            { value: true, label: "Active" },
            { value: false, label: "Un Active" },
          ]}
        />
      </div>

      <TablePaginate
        count={count}
        page={page}
        setPage={setPage}
        size={size}
        columns={columns}
        data={items}
      />

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openRoyalty}
        closeAfterTransition
      >
        <Box sx={styleModal}>
          <h4 style={{ textAlign: "center", fontWeight: "bold" }}>SET ROYALTY</h4>
          {!wallet ? (
            <ButtonMui
              onClick={() => connectWallet()}
              variant="contained"
              style={{ display: "block", margin: "0 auto" }}
            >
              Connect Wallet
            </ButtonMui>
          ) : (
            <>
              <div>
                <p style={{ textAlign: "center" }}>
                  <strong>Connected:</strong> {wallet}
                </p>
              </div>
              <RoyalItem
                value={royalties?.[0]}
                index={0}
                onChange={(updatedValue) =>
                  handleAddRoyalties(updatedValue.payee, updatedValue.royalty, 0)
                }
              />
              <RoyalItem
                value={royalties?.[1]}
                index={1}
                onChange={(updatedValue) =>
                  handleAddRoyalties(updatedValue.payee, updatedValue.royalty, 1)
                }
              />
              <RoyalItem
                value={royalties?.[2]}
                index={2}
                onChange={(updatedValue) =>
                  handleAddRoyalties(updatedValue.payee, updatedValue.royalty, 2)
                }
              />

              <p>Total: {totalPercent}%</p>
              {totalPercent > 15 && (
                <p style={{ color: "red" }}>Total royalty must not exceed 15%.</p>
              )}
              <div
                style={{
                  marginTop: "50px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                {loading ? (
                  <>
                    <ButtonMui>Cancel</ButtonMui>
                    <ButtonMui variant="contained">
                      <CircularProgress size={20} color="inherit" />
                    </ButtonMui>
                  </>
                ) : (
                  <>
                    <ButtonMui onClick={handleCloseRoyalty}>Cancel</ButtonMui>
                    <ButtonMui onClick={() => handleConfirmRoyalty()} variant="contained">
                      Confirm
                    </ButtonMui>
                  </>
                )}
              </div>
            </>
          )}
        </Box>
      </Modal>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openMarketFee}
        closeAfterTransition
      >
        <Box sx={styleModal}>
          <h4 style={{ textAlign: "center", fontWeight: "bold" }}>Set MarketFee</h4>
          {!wallet ? (
            <ButtonMui
              onClick={() => connectWallet()}
              variant="contained"
              style={{ display: "block", margin: "0 auto" }}
            >
              Connect Wallet
            </ButtonMui>
          ) : (
            <>
              <div>
                <p style={{ textAlign: "center" }}>
                  <strong>Connected:</strong> {wallet}
                </p>
              </div>
              <div>
                <div>
                  <label
                    style={{
                      display: "block",
                      color: "#000",
                      marginBottom: "5px",
                    }}
                  >
                    Market Fee
                  </label>
                  <input
                    style={{
                      display: "block",
                      width: "100%",
                      padding: "8px 10px",
                      marginBottom: "15px",
                      borderRadius: "5px",
                      border: "1px solid #000",
                    }}
                    type="text"
                    value={marketFee}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^$|^(100(\.0?)?|\d{1,2}(\.\d?)?)$/.test(value)) {
                        setMarketFee(value);
                      }
                    }}
                  />
                </div>
              </div>
              <div
                style={{
                  marginTop: "50px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                {loading ? (
                  <>
                    <ButtonMui>Cancel</ButtonMui>
                    <ButtonMui variant="contained">
                      <CircularProgress size={20} color="inherit" />
                    </ButtonMui>
                  </>
                ) : (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: collection?.marketFee > 0 ? "space-between" : "flex-end",
                    }}
                  >
                    {collection?.marketFee > 0 && (
                      <ButtonMui
                        variant="contained"
                        color="error"
                        onClick={handleDeleteFee}
                        disabled={loading || loadingDeleteFee}
                      >
                        {loadingDeleteFee ? (
                          <CircularProgress size={20} color="inherit" />
                        ) : (
                          "Delete fee"
                        )}
                      </ButtonMui>
                    )}

                    <div>
                      <ButtonMui
                        disabled={loading || loadingDeleteFee}
                        onClick={handleCloseMarketFee}
                      >
                        Cancel
                      </ButtonMui>
                      <ButtonMui
                        onClick={handleConfirmMarketFee}
                        variant="contained"
                        disabled={loading || loadingDeleteFee}
                      >
                        {loading ? <CircularProgress size={20} color="inherit" /> : "Confirm"}
                      </ButtonMui>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </Box>
      </Modal>
    </div>
  );
}

IsHot.propTypes = {
  cell: PropTypes.any,
};

function IsHot({ cell }) {
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    setChecked(cell.value);
  }, [cell]);

  function onChange(e) {
    setChecked(e.target.checked);
    toogleChecked(e.target.checked);
  }

  async function toogleChecked(isChecked) {
    const id = cell.row.original.id;
    try {
      const { data } = await collectionService.update(id, { isHot: isChecked });
      toast.success("Updated collections");
    } catch (e) {
      toast.error(e.response.data.message[0]);
    }
  }
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      inputProps={{ "aria-label": "controlled" }}
      color="primary"
    />
  );
}

IsActivated.propTypes = {
  cell: PropTypes.any,
};

function IsActivated({ cell }) {
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    setChecked(cell.value);
  }, [cell]);

  function onChange(e) {
    setChecked(e.target.checked);
    toogleChecked(e.target.checked);
  }

  async function toogleChecked(isChecked) {
    const id = cell.row.original.id;
    try {
      const { data } = await collectionService.update(id, {
        activated: isChecked,
      });
      console.log(data);
      toast.success("Updated collections");
    } catch (e) {
      toast.error(e.response.data.message[0]);
    }
  }
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      inputProps={{ "aria-label": "controlled" }}
      color="primary"
    />
  );
}

function Action({ setItems, cell }) {
  const [openDialogDel, setOpenDialogDel] = useState(false);

  const handleOpenDel = () => {
    setOpenDialogDel(true);
  };

  const handleCloseDel = () => {
    setOpenDialogDel(false);
  };

  const handleDelete = async (id) => {
    try {
      await collectionService.remove(id);
      setItems((prev) => prev.filter((banner) => banner._id !== id));
      handleCloseDel();
    } catch (error) {
      console.log(error);
    }
  };

  const handleExport = async (address) => {
    try {
      const { data } = await collectionService.exportRank(
        ethers.utils.getAddress(address.toLowerCase()),
      );
      const json = JSON.stringify(data);
      const blob = new Blob([json], { type: "application/json" });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.setAttribute("hidden", "");
      a.setAttribute("href", url);
      a.setAttribute("download", "rank.json");
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      handleCloseDel();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="actions-right">
      <Button
        justIcon
        round
        simple
        color="warning"
        className="edit"
        onClick={() => handleOpenDel()}
      >
        <Delete />
      </Button>

      <Button
        justIcon
        round
        simple
        color="warning"
        className="edit"
        onClick={() => handleExport(cell.row.original.address)}
      >
        <CloudDownload />
      </Button>

      <Dialog
        open={openDialogDel}
        onClose={handleCloseDel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm remove collection"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleCloseDel} color="transparent">
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleDelete(cell.row.original._id);
            }}
            color="success"
          >
            Agree
          </Button>
        </DialogActions>
      </Dialog>

      <Link to={"/admin/collection/" + cell.row.original._id}>
        <Button justIcon round simple color="primary" className="edit">
          <Edit />
        </Button>
      </Link>

      <a
        href={`${FE_LINK}/collection/${cell.row.original._id}?chain=${cell.row.original.chainId}`}
        target="_blank"
      >
        <Button justIcon round simple color="success" className="edit">
          <LinkSharp />
        </Button>
      </a>
    </div>
  );
}

Action.propTypes = {
  cell: PropTypes.any,
  onCloseModal: PropTypes.any,
};

function View({ cell }) {
  return (
    <div className="actions-right">
      <Link to={"/admin/collection/" + cell.row.original.id}>
        <Button justIcon round simple color="success" className="edit">
          <Visibility />
        </Button>
      </Link>
    </div>
  );
}

View.propTypes = {
  cell: PropTypes.any,
};

const RoyalItem = ({ value = {}, index, onChange }) => {
  console.log(value);

  return (
    <GridContainer>
      <GridItem xs={12} sm={9} md={8}>
        <div>
          <label
            style={{
              display: "block",
              color: "#000",
              marginBottom: "5px",
            }}
          >
            Payee
          </label>
          <input
            style={{
              display: "block",
              width: "100%",
              padding: "8px 10px",
              marginBottom: "15px",
              borderRadius: "5px",
              border: "1px solid #000",
            }}
            value={value?.payee || ""}
            onChange={(e) =>
              onChange({
                ...value, // Giữ nguyên các giá trị khác
                payee: e.target.value, // Cập nhật payee
              })
            }
          />
        </div>
      </GridItem>
      <GridItem xs={4} sm={3} md={4}>
        <div>
          <label
            style={{
              display: "block",
              color: "#000",
              marginBottom: "5px",
            }}
          >
            Royalty
          </label>
          <input
            style={{
              display: "block",
              width: "100%",
              padding: "8px 10px",
              marginBottom: "15px",
              borderRadius: "5px",
              border: "1px solid #000",
            }}
            value={
              value?.royalty
                ? ethers.BigNumber.from(value.royalty).toString() // Hiển thị số từ BigNumber
                : ""
            }
            onChange={(e) =>
              onChange({
                ...value, // Giữ nguyên các giá trị khác
                royalty: e.target.value, // Cập nhật royalty
              })
            }
          />
        </div>
      </GridItem>
    </GridContainer>
  );
};
